import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import MenuPage from "@/pages/MenuPage";
import GalleryPage from "@/pages/GalleryPage";
import LocationPage from "@/pages/LocationPage";
import ContactPage from "@/pages/ContactPage";
import FranchisePage from "@/pages/FranchisePage";
import PrivacyPage from "@/pages/PrivacyPage";
import DataDeletionPage from "@/pages/DataDeletionPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import AdminCMSPage from "@/pages/AdminCMSPage";

// Scroll to top on route change
function ScrollToTop() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<><ScrollToTop /><HomePage /></>} />
            <Route path="/about" element={<><ScrollToTop /><AboutPage /></>} />
            <Route path="/menu" element={<><ScrollToTop /><MenuPage /></>} />
            <Route path="/gallery" element={<><ScrollToTop /><GalleryPage /></>} />
            <Route path="/location" element={<><ScrollToTop /><LocationPage /></>} />
            <Route path="/contact" element={<><ScrollToTop /><ContactPage /></>} />
            <Route path="/franchise" element={<><ScrollToTop /><FranchisePage /></>} />
            <Route path="/privacy" element={<><ScrollToTop /><PrivacyPage /></>} />
            <Route path="/data-deletion" element={<><ScrollToTop /><DataDeletionPage /></>} />
            <Route path="/admin" element={<><ScrollToTop /><AdminDashboardPage /></>} />
            <Route path="/admin/content" element={<><ScrollToTop /><AdminCMSPage /></>} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
